"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMediaItem = exports.updateMediaItem = exports.getMediaItems = exports.uploadMediaItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _services = require("../services");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var uploadMediaItem = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, file, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, file = _ref.file;
            _context.next = 3;
            return _services.mediaServices.addMediaItem({
              siteID: siteID,
              file: file
            }, dispatch, config);

          case 3:
            result = _context.sent;

            if (result) {
              dispatch({
                type: "ADD_MEDIA_ITEM",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: siteID
                })
              });
            }

            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadMediaItem(_x, _x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.uploadMediaItem = uploadMediaItem;

var getMediaItems = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, page, limit, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, page = _ref2.page, limit = _ref2.limit;
            _context2.next = 3;
            return _services.mediaServices.getMediaItems({
              siteID: siteID,
              page: page,
              limit: limit
            }, dispatch, config);

          case 3:
            result = _context2.sent;

            if (result) {
              dispatch({
                type: "ADD_MEDIA_ITEMS",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: siteID
                })
              });
            }

            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getMediaItems(_x4, _x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

exports.getMediaItems = getMediaItems;

var updateMediaItem = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, id, altText, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, id = _ref3.id, altText = _ref3.altText;
            _context3.next = 3;
            return _services.mediaServices.updateMediaItem({
              siteID: siteID,
              id: id,
              altText: altText
            }, dispatch, config);

          case 3:
            result = _context3.sent;

            if (result) {
              dispatch({
                type: "ADD_MEDIA_ITEM",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: siteID
                })
              });
            }

            return _context3.abrupt("return", result);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateMediaItem(_x7, _x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();

exports.updateMediaItem = updateMediaItem;

var deleteMediaItem = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            siteID = _ref4.siteID, id = _ref4.id;
            _context4.next = 3;
            return _services.mediaServices.deleteMediaItem({
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context4.sent;

            if (result) {
              dispatch({
                type: "DELETE_MEDIA_ITEM",
                payload: {
                  id: result,
                  siteID: siteID
                }
              });
            }

            return _context4.abrupt("return", result);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteMediaItem(_x10, _x11, _x12) {
    return _ref8.apply(this, arguments);
  };
}();

exports.deleteMediaItem = deleteMediaItem;